define.alias("shared/components/shared/ui/dynamic-social-set", "media/components/shared/ui/dynamic-social-set");